// extracted by mini-css-extract-plugin
export default {"home__section":"Home_home__section__B9hGk","margin_top_40":"Home_margin_top_40__lWGaQ"};